import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPeopleIdCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeopleIdCard"><Path d="M19.5 2.5H4.5V21.5H19.5V2.5Z" stroke="currentColor"/><Circle cx="12" cy="11.5" r="2.5" stroke="currentColor"/><Path d="M17 21C17 18.2386 14.7614 16 12 16C9.23858 16 7 18.2386 7 21" stroke="currentColor"/><Path d="M9 5.5H15" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeopleIdCard;
